<template>
    <div id="phone-input">
        <VuePhoneNumberInput
            no-example
            no-validator-state
            :required="required"
            :translations="{
                countrySelectorLabel: $t('code'),
                phoneNumberLabel: $t('phone'),
            }"
            v-model="content"
            :defaultCountryCode="countryCode"
            @update="onUpdate"
        />
    </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
    name: 'CustomPhoneInput',
    components: {
        VuePhoneNumberInput,
    },
    props: {
        /**
         * These are the params that the update function receives inside a payload
         * @param {String} countryCode
         * @param {Boolean} isValid
         * @param {String} phoneNumber
         * @param {String} countryCallingCode
         * @param {String} formattedNumber
         * @param {String} nationalNumber
         * @param {Bool} required
         *
         */
        onUpdate: {
            type: Function,
            required: true,
        },
        countryCode: {
            type: String,
            default: '55',
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        '$attrs.value': function () {
            this.content = this.$attrs.value
        },
    },
    data() {
        return {
            content: null,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$nextTick(() => {
                this.content = this.$attrs.value
            })
        })
    },
}
</script>

<style lang="scss">
#phone-input {
    display: block;
    width: 100%;
    background-color: inherit;
    .vue-phone-number-input {
        background-color: inherit;
        .input-country-selector,
        .input-phone-number {
            background-color: inherit;
            label {
                font-family: lato;
            }
            input {
                color: white;
                background-color: inherit;
            }
        }

        .country-selector__list {
            background-color: #18181a;
            div {
                color: white !important;
            }
        }

        .country-selector__label,
        .country-selector__country-flag {
            cursor: pointer;
            pointer-events: none;
        }
    }
}
</style>
